"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BufferList = void 0;
/**
 * Stores a list of items of fixed size. The oldest is pushed off when its full
 */
var BufferList = /** @class */ (function () {
    function BufferList(maxSize) {
        this.maxSize = maxSize;
        this.items = [];
    }
    /**
     * Pushes item on to the end of the buffer list.
     * If an item is removed from the list because its reached the max size,
     * it will be returned
     */
    BufferList.prototype.push = function (item) {
        this.items.push(item);
        if (this.items.length > this.maxSize) {
            return this.items.shift();
        }
        return;
    };
    /**
     * Gets newest item. Returns null if empty
     */
    BufferList.prototype.getNewest = function () {
        var _a;
        return this.items.length === 0
            ? null
            : (_a = this.items[this.items.length - 1]) !== null && _a !== void 0 ? _a : null;
    };
    /**
     * Get all items in array sorted from oldest to latest
     */
    BufferList.prototype.getItems = function () {
        return __spreadArray([], __read(this.items), false);
    };
    /**
     * Filters the elements in the list
     */
    BufferList.prototype.filter = function (filterFunc) {
        this.items = this.items.filter(filterFunc);
    };
    return BufferList;
}());
exports.BufferList = BufferList;
